import { render, staticRenderFns } from "./menu_tree.vue?vue&type=template&id=d49a931a&"
import script from "./menu_tree.vue?vue&type=script&lang=js&"
export * from "./menu_tree.vue?vue&type=script&lang=js&"
import style0 from "./menu_tree.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports